module.exports = __webpack_public_path__ + "img/made-with-movement-black.bedc0b89.svg";